import React, {useEffect, useState} from "react";
import ReactDom from "react-dom";
import RestRequest from "../../tools/RestRequest";
import config from "../../config";
import Currency from "../../tools/Currency";

function QuickCalc({from, to, product_id}) {

    const [tarrifs, setTarriffs] = useState([]);

    useEffect(() => {
        let params = new FormData();
        params.append('from', from);
        params.append('to', to);
        params.append('product_id', product_id);

        RestRequest.post(config.restTariffs, {
            body: params
        }).then((data) => {
            setTarriffs(data);
        });
    }, []);

    return <div className="quick-calc-list">
        {tarrifs.map((el, index) => {
            return <div className="quick-calc-list-item" key={index}>
                <div className="quick-calc-list-item-data">
                    <div className="quick-calc-list-item__name">{el.name}</div>
                    <div className="quick-calc-list-item__money">Стоимость {el.total_sum} {Currency.show()}</div>
                    <div className="quick-calc-list-item__days">Доставка {el.min_day}-{el.max_day} дней</div>
                </div>
                <div className="quick-calc-list-item-image">
                    <img src={el.image}/>
                </div>
            </div>
        })}
    </div>
}


let element = document.querySelector('.quick-calc-rest');
if (element) ReactDom.render(<QuickCalc from={element.getAttribute('data-from')} to={element.getAttribute('data-to')} product_id={element.getAttribute('data-product-id')}/>, element);